import type { Organizer } from "./types";

export const mainOrganizer = {
  title:
    "Южно – Российский институт управления – филиал Российской академии народного хозяйства и государственной службы при Президенте Российской Федерации",
  location: "(г. Ростов-на-Дону)",
};

export const coOrganizers: Organizer[] = [
  {
    title: "Ферганский Государственный Университет",
    location: "(Республика Узбекистан, г. Фергана)",
    logo: "./assets/img/so-organizers/1.png",
  },
  {
    title: "Институт экономики — Карельский научный центр РАН",
    location: "(Россия, г. Петрозаводск)",
    logo: "./assets/img/so-organizers/2.png",
  },
  {
    title: "Южный федеральный университет",
    location: "(Россия, г. Ростов-на-Дону)",
    logo: "./assets/img/so-organizers/3.png",
  },
  {
    title: "Абхазский Государственный университет",
    location: "(Республика Абхазия, г. Сухум)",
    logo: "./assets/img/so-organizers/4.png",
  },
  {
    title: "Университет социальных наук",
    location: "(Турция, г. Анкара)",
    logo: "./assets/img/so-organizers/5.png",
  },
  {
    title: "Академия управления при Президенте Республики Беларусь",
    location: "(Республика Беларусь, г. Минск)",
    logo: "./assets/img/so-organizers/6.png",
  },
  {
    title: " Тюменский государственный университет",
    location: "(г. Тюмень)",
    logo: "./assets/img/so-organizers/7.jpg",
  },
];
